import { Box, Switch, Typography } from "@mui/material";
import { Done } from "@mui/icons-material";

import Theme from "../../../../../utils/Theme";
import { SalesAidsStyles } from "./SalesAidsStyles";

const WarrantyArtifacts = ({
  artifacts,
  setArtifacts,
  handleArrowClick,
  order,
  setOrder,
}) => {
  const handleSwitchChange = (e) => {
    const isEnabled = e.target.checked;

    setArtifacts((prev) => ({
      ...prev,
      warranty: {
        ...prev?.warranty,
        is_enabled: isEnabled,
        isEdit: true,
        // Clear position when disabling so it isn't silently re-saved
        // with a stale position once removed from the execution sequence.
        position: isEnabled ? prev?.warranty?.position : null,
      },
    }));

    // If warranty was previously added to the execution sequence,
    // remove it now that the module has been disabled.
    if (!isEnabled) {
      setOrder((prevOrder) =>
        prevOrder.filter(
          (item) => item.artifactId !== artifacts?.artifactId,
        ),
      );
    }
  };

  return (
    <Box sx={SalesAidsStyles.outerBox}>
      <Box
        sx={{
          ...SalesAidsStyles.innerBox,
          bgcolor: artifacts?.isEdit ? "#FFF7F7" : null,
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 0.5,
            flexShrink: 0,
          }}
        >
          <Typography sx={SalesAidsStyles.wordStyle}>
            Warranty Module Enable
          </Typography>
          <Switch
            checked={!!artifacts?.is_enabled}
            size="small"
            onChange={handleSwitchChange}
          />
        </Box>

        <Done
          sx={{
            ...SalesAidsStyles.doneIcon,
            mt: 0,
            flexShrink: 0,
            color: artifacts?.is_enabled
              ? Theme.palette.primary.main
              : Theme.palette.action.disabled,
            cursor: artifacts?.is_enabled ? "pointer" : "not-allowed",
          }}
          onClick={() =>
            artifacts?.is_enabled && handleArrowClick(artifacts, "warranty")
          }
        />
      </Box>
    </Box>
  );
};

export default WarrantyArtifacts;